<template>
  <div class="student_status_content">
    <el-form
      ref="formLeft"
      style="margin-right:30px;"
      :model="query"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="就读学校" prop="school">
        <el-input style="width:232px" disabled v-model="query.school" placeholder="请输入学校名称"></el-input>
      </el-form-item>
      <el-form-item label="入学时间" prop="startSchoolDate">
        <el-date-picker
          style="width:232px"
          :disabled="isDisabledNormal"
          v-model="query.startSchoolDate"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="就读专业" prop="major">
        <el-input
          style="width:232px"
          :disabled="isDisabled"
          v-model="query.major"
          placeholder="请输入专业名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="学生证号码" prop="studentNumber">
        <el-input
          style="width:232px"
          :disabled="isDisabledNormal"
          v-model="query.studentNumber"
          placeholder="请输入学生证号码"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form ref="formRight" :model="query" :rules="rules" label-width="112px">
      <el-form-item label="学校编号">
        <el-input style="width:217px!important" disabled v-model="query.code" placeholder="请输入学校编号"></el-input>
      </el-form-item>
      <el-form-item label="入学性质" prop="sportsLevel">
        <el-select :popper-append-to-body="false" :disabled="isDisabledNormal" v-model="query.sportsLevel" placeholder="请选择入学性质">
          <el-option
            v-for="(item,index) in natureList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学制" prop="schoolSystem">
        <el-select :popper-append-to-body="false" :disabled="isDisabled" v-model="query.schoolSystem" placeholder="请选择学制">
          <el-option
            v-for="(item,index) in educationalList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原毕业学校">
        <el-input :disabled="isDisabled" v-model="query.sourceSchool" placeholder="请输入原毕业学校"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
import { getSession } from "@/utils/storage.js";
import { getSchool } from "@/api/athletes";
export default {
  props: {
    formInfo: {
      type: Object
    },
    operation: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      query: {
        school: "",
        startSchoolDate: "",
        sportsLevel: "",
        code: "",
        major: "",
        schoolSystem: "",
        studentNumber: "",
        sourceSchool: ""
      },
      schoolList: [],
      rules: {
        school: [
          { required: true, message: "学校名称不能为空", trigger: "blur" }
        ],
        startSchoolDate: [
          {
            required: true,
            message: "入学时间不能为空",
            trigger: "change"
          }
        ],
        sportsLevel: [
          { required: true, message: "入学性质不能为空", trigger: "change" }
        ],
        major: [
          { required: true, message: "就读专业不能为空", trigger: "blur" }
        ],
        schoolSystem: [
          { required: true, message: "学制不能为空", trigger: "change" }
        ],
        studentNumber: [
          { required: true, message: "学生证号码不能为空", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    // 判断是否禁用表单组件输入
    isDisabled() {
      if (this.operation) {
        return this.operation === "watch" ? true : false;
      }
      return false;
    },
    // 表单组件默认不可修改
    isDisabledNormal() {
      
      if(this.operation === 'watch') return true;
      if (this.formInfo && this.formInfo.name) {
        if (
          this.formInfo.state === 0 ||
          this.formInfo.state === 2 ||
          this.formInfo.state === 4
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    educationalList() {
      return registerData.educationalList;
    },
    natureList() {
      return registerData.natureList;
    }
  },
  methods: {
    submits() {
      return Promise.all([
        this.$refs["formLeft"].validate(),
        this.$refs["formRight"].validate()
      ])
        .then(res => {
          return Promise.resolve(this.query);
        })
        .catch(err => {
          this.$message.warning("请完善学籍信息");
          return null;
        });
    }
  },
  watch: {
    formInfo(value) {
      if (value) {
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }

        this.$set(this.query, "school", value.schoolName);
        this.schoolList.filter(item => {
          if (item.name === this.query.school)
            this.$set(this.query, "code", item.code);
        });
      }
    }
  },
  mounted() {
    let userInfo = getSession("userInfo") || null;
    if (userInfo) {
      Object.assign(this.query, {
        school: JSON.parse(userInfo).schoolName,
        code: JSON.parse(userInfo).code
      });
    }
    getSchool({})
      .then(res => {
        this.schoolList = res;
      })
      .catch(err => {});
  }
};
</script>
<style lang="less" scoped>
.student_status_content {
  display: flex;
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
}
</style>